import {privateAPI} from "./api/api";
import {ApiErrorHandler} from "./api/api-error";

const BASE_URL = '/products-analysis-import/';
const config = {
    headers: {
        'accept': 'application/json',
        'content-type': 'multipart/form-data'
    }
}

const importProductsAnalysis = async (formData) => {
    try {
        const response = await privateAPI.post(`${BASE_URL}import`, formData, config);
        return response.data;
    } catch (error) {
        error.message = ApiErrorHandler.getErrorMessage(error);
        throw error;
    }
}

export const productsAnalysisImportService = {
    importProductsAnalysis: importProductsAnalysis,
};
